import { render, staticRenderFns } from "./advertisingRevenue.vue?vue&type=template&id=270c5324&scoped=true&"
import script from "./advertisingRevenue.vue?vue&type=script&lang=js&"
export * from "./advertisingRevenue.vue?vue&type=script&lang=js&"
import style0 from "./advertisingRevenue.vue?vue&type=style&index=0&id=270c5324&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c5324",
  null
  
)

export default component.exports